/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Address1
 */
export interface Address1 {
}

/**
 * Check if a given object implements the Address1 interface.
 */
export function instanceOfAddress1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Address1FromJSON(json: any): Address1 {
    return Address1FromJSONTyped(json, false);
}

export function Address1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Address1 {
    return json;
}

export function Address1ToJSON(value?: Address1 | null): any {
    return value;
}

